import styled from "styled-components";

export const ChatsContainer = styled.div`
    display: flex;
    padding: 10px 20px;
    gap: 10px;
    width: 100%;
    height: 100%;
`